import React, { useEffect } from 'react';
import { Box, Typography, Icons } from '@curves/ui-base';
import { useHistory, useLocation } from 'react-router-dom';
import { useMainLayoutContext } from '@Local/Components/Layout/Context/MainLaydoutContext';
import { FOOTER_TYPE, HEADER_TYPE, THEME_TYPE } from '@Constants/dataEnums';
import { MEMBER_REDEEM_ROUTER } from '@Router/routerPath';

/** 兌換贈品說明頁。資料由選品頁經路由 state 帶入（location.state: { product }），不呼叫 API。 */
const RedeemProductGuidePage = () => {
    const { setHeaderType, setFooterType, setThemeType, setHeaderContent } = useMainLayoutContext();
    const history = useHistory();
    const location = useLocation();
    const { product = null } = location.state || {};

    // 不可改用 replace，要回到選品頁那個 entry 才還原得到草稿
    const handleBack = () => history.goBack();

    // 功能：守衛＋版面
    useEffect(() => {
        setHeaderType(HEADER_TYPE.DEFAULT);
        setFooterType(FOOTER_TYPE.HIDE);
        setThemeType(THEME_TYPE.DEFAULT);
        setHeaderContent(
            <Box className="redeem-product-guide-header">
                <button type="button" className="redeem-product-guide-back" onClick={handleBack}>
                    <Icons.KeyboardArrowLeft />
                </button>
                <Typography className="redeem-product-guide-title">贈品說明</Typography>
            </Box>,
        );

        if (!location.state?.product) history.replace(MEMBER_REDEEM_ROUTER);

        return () => setHeaderContent(null);
        // eslint-disable-next-line
    }, [history, setHeaderType, setFooterType, setThemeType, setHeaderContent]);

    if (!product) return null;

    return (
        <Box className="redeem-product-guide-page">
            <Box className="container">
                <Box className="redeem-product-guide-summary">
                    {product.imageSrc && (
                        <img
                            className="redeem-product-guide-main-img"
                            src={product.imageSrc}
                            alt={product.itemName}
                        />
                    )}
                    <Box className="redeem-product-guide-info">
                        <Typography className="redeem-product-guide-name">{product.itemName}</Typography>
                        {product.sku && (
                            <Typography className="redeem-product-guide-sku">SKU：{product.sku}</Typography>
                        )}
                        <Typography className="redeem-product-guide-points-label">兌換點數</Typography>
                        <Typography className="redeem-product-guide-points">
                            <span className="redeem-product-guide-points-value">{product.points}</span> 點
                        </Typography>
                        {product.costPrice > 0 && (
                            <Typography className="redeem-product-guide-price">
                                市價 ${product.costPrice.toLocaleString()}
                            </Typography>
                        )}
                    </Box>
                </Box>
                {product.descriptionImage && (
                    <img
                        className="redeem-product-guide-desc-img"
                        src={product.descriptionImage}
                        alt={`${product.itemName} 說明圖`}
                    />
                )}
            </Box>
        </Box>
    );
};

export default RedeemProductGuidePage;
